/* eslint-disable no-restricted-syntax */
import api from '@cannect/services/api'
import { TDefaultOptionResponse } from '@cannect/services/common'
import { TResponseStandard } from '@cannect/services/types'
import { TSchedulingDatesDefaultParams, TSchedulingPrescriberListItem } from './types'

export const getExpertisesFiltersOptions = async () => {
  return api
    .get<TResponseStandard<TDefaultOptionResponse[], 'expertises'>>('/scheduling/filters/expertises')
    .then((res) => res.data)
}

export const getPathologiesFiltersOptions = async () => {
  return api
    .get<TResponseStandard<TDefaultOptionResponse[], 'pathologies'>>('/scheduling/filters/pathologies')
    .then((res) => res.data)
}

export const getPrescribersFiltersOptions = async () => {
  return api
    .get<TResponseStandard<TDefaultOptionResponse[], 'prescribers'>>('/scheduling/filters/prescribers')
    .then((res) => res.data)
}

export const getAvailableDates = async ({ filterBy }: TSchedulingDatesDefaultParams) => {
  return api
    .get<
      TResponseStandard<number[], 'available_date_times'>
    >(`/scheduling/availability/dates?${filterBy?.type}=${filterBy?.value}`)
    .then((res) => res.data)
}

export const getAvailablePrescribers = async ({
  filterBy,
  dateTime,
  sortBy,
  orderBy,
  attendsChildren
}: TSchedulingDatesDefaultParams) => {
  const queryParts: string[] = []

  if (filterBy?.type === 'prescribers_ids') {
    try {
      const ids = JSON.parse(filterBy.value || '[]')
      queryParts.push(...ids.map((id: number) => `prescribers_ids[]=${id}`))
    } catch (error) {
      if (filterBy.value) queryParts.push(`${filterBy.type}=${filterBy.value}`)
    }
  } else if (filterBy?.value) {
    queryParts.push(`${filterBy.type}=${filterBy.value}`)
  }

  if (attendsChildren) queryParts.push('attends_children=true')

  const queryString = queryParts.join('&')

  return api
    .get<
      TResponseStandard<TSchedulingPrescriberListItem[], 'prescribers'>
    >(`/scheduling/availability/prescribers?${queryString}`, { params: { dateTime, sortBy, orderBy } })
    .then((res) => res.data)
}

export type TCreateAppointmentPayload = {
  origin: string
  patient_id?: number
  prescriber_id: number
  date: string
  hour: string
  duration?: number
  prescriber_user_id?: number
  cpf?: string | null
  rne?: string | null
  origin_scheduling_id?: number
  screening_token?: string
}

export const createAppointment = async (payload: TCreateAppointmentPayload) => {
  const { data } = await api.post<{ success: boolean; appointment?: unknown; message?: string }>(
    '/scheduling/appointment',
    payload
  )
  return data
}
